import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncProfile = loadable(() => import('./Profile'), {
  fallback: <Loader />,
});
